import { z } from 'zod';

export const acceptInviteSchema = z.object({
  token: z.string().min(10).max(128),
  displayName: z.string().min(1).max(40),
});

export const createInviteSchema = z.object({}).strict();

export type AcceptInvite = z.infer<typeof acceptInviteSchema>;
